import { Button, Flex, FormField, FormItem } from '@/src/ui-components';
import { useFormContext } from 'react-hook-form';
import { TradePanelFormValues } from '../../trade-panel.types';

export const BuySell = () => {
  const { watch, control } = useFormContext<TradePanelFormValues>();
  const orderType = watch('orderType');

  return (
    <FormField
      control={control}
      name="orderType"
      render={({ field }) => (
        <FormItem>
          <Flex align="center" justify="evenly" gap="2">
            <Button
              className={`w-full ${orderType === 'buy' ? 'bg-bullish hover:bg-bullish/90 text-white' : 'border-bullish text-bullish hover:bg-bullish/10'}`}
              type="button"
              variant={orderType === 'buy' ? 'default' : 'outline'}
              onClick={() => field.onChange('buy')}
            >
              Buy
            </Button>
            <Button
              className={`w-full ${orderType === 'sell' ? 'bg-bearish hover:bg-bearish/90 text-white' : 'border-bearish text-bearish hover:bg-bearish/10'}`}
              type="button"
              variant={orderType === 'sell' ? 'default' : 'outline'}
              onClick={() => field.onChange('sell')}
            >
              Sell
            </Button>
          </Flex>
        </FormItem>
      )}
    />
  );
};
